import React, { useState, useEffect } from 'react';

import { useBreadcrumbs } from '../../hooks';
import { usePaginatedPlayers } from './usePaginatedPlayers';
import PlayerSelection from './PlayerSelection';
import { useLeagues } from '../TeamSelection/useLeagues';
import { useSeasons } from '../TeamSelection/useSeasons';
import { usePaginatedTeams } from '../TeamSelection/usePaginatedTeams';

const createBreadcrumbs = () => [{ title: 'Players' }];

const PlayerSelectionPage = () => {
  useBreadcrumbs(createBreadcrumbs, []);

  const [playerName, setPlayerName] = useState();
  useEffect(() => {
    setPlayerName(playerName);
  }, [playerName]);
  const handlePlayerNameChange = playerName => {
    setPlayerName(playerName);
  };

  // leagues
  const leagues = useLeagues();
  const [league, setLeague] = useState();

  const handleLeagueChange = id => {
    id = +id;
    const league = leagues.find(l => l.id === id);
    setLeague(league);
  };
  // seasons
  const seasons = useSeasons(league);
  const [season, setSeason] = useState();
  const handleSeasonChange = id => {
    id = +id;
    const season = seasons.find(l => l.id === id);
    setSeason(season);
  };

  // teams
  const teamsPageSize = 1000;
  const { teams } = usePaginatedTeams(
    league,
    season,
    null, // don't filter by name
    0, // first page
    teamsPageSize,
  );
  const [team, setTeam] = useState();
  const handleTeamChange = team => {
    setTeam(team);
  };

  useEffect(() => {
    setSeason(null);
    setTeam(null);
  }, [league]);

  // players
  const playersPageSize = 30;
  const [playersCurrentPage, setPlayersCurrentPage] = useState(0);
  const { playersCount, players } = usePaginatedPlayers(
    playerName,
    playersCurrentPage,
    playersPageSize,
    season,
    league,
    team,
  );

  return (
    <PlayerSelection
      onPlayerNameChange={handlePlayerNameChange}
      playerName={playerName}
      players={players}
      playersCount={playersCount}
      playersCurrentPage={playersCurrentPage}
      playersPageSize={playersPageSize}
      onPageChange={setPlayersCurrentPage}
      league={league}
      leagues={leagues}
      onLeagueChange={handleLeagueChange}
      onSeasonChange={handleSeasonChange}
      season={season}
      seasons={seasons}
      team={team}
      teams={teams}
      onTeamChange={handleTeamChange}
    />
  );
};

export default PlayerSelectionPage;
